import { useEffect, useState } from 'react';
import { Loader2Icon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const InstagramDirectCallback = () => {
  const [status, setStatus] = useState('processing'); // 'processing', 'success', 'error'
  const [message, setMessage] = useState(
    'Processing Instagram Direct connection...'
  );
  const navigate = useNavigate();
  const isPopup = window.opener !== null;

  useEffect(() => {
    const handleCallback = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const statusParam = urlParams.get('status');
      const messageParam = urlParams.get('message');

      // Handle status and message params
      if (statusParam === 'success') {
        setStatus('success');
        setMessage(messageParam || 'Instagram Direct connected successfully!');

        if (isPopup) {
          // Popup: close window after showing success
          setTimeout(() => {
            window.close();
          }, 1000);
        } else {
          // Not a popup: navigate to settings page
          setTimeout(() => {
            navigate('/settings/instagram-direct');
          }, 1000);
        }
      } else if (statusParam === 'error') {
        setStatus('error');
        setMessage(messageParam || 'Instagram Direct connection failed');

        if (!isPopup) {
          // Not a popup: navigate to settings page after showing error
          setTimeout(() => {
            navigate('/settings/instagram-direct');
          }, 3000);
        }

        // If popup, don't close on error - let user see the error and close manually
      } else {
        // Still processing or unknown status
        setStatus('processing');
        setMessage('Processing Instagram Direct connection...');
      }
    };

    handleCallback();
  }, [isPopup, navigate]);

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'text-green-600';
      case 'error':
        return 'text-red-600';
      default:
        return 'text-blue-600';
    }
  };

  const getStatusIcon = () => {
    if (status === 'processing') {
      return <Loader2Icon className='h-8 w-8 animate-spin text-blue-600' />;
    }
    return null;
  };

  return (
    <div className='flex min-h-screen items-center justify-center bg-background p-4'>
      <div className='max-w-md space-y-4 text-center'>
        <div className='flex justify-center'>{getStatusIcon()}</div>
        <h2 className='text-xl font-semibold'>Instagram Direct Connection</h2>
        <p className={`text-lg ${getStatusColor()}`}>{message}</p>
        {status === 'success' && (
          <p className='text-sm text-muted-foreground'>
            {isPopup
              ? 'This window will close automatically...'
              : 'Redirecting to settings...'}
          </p>
        )}
        {status === 'error' && (
          <p className='text-sm text-muted-foreground'>
            {isPopup
              ? 'You can close this window manually.'
              : 'Redirecting to settings...'}
          </p>
        )}
      </div>
    </div>
  );
};

export default InstagramDirectCallback;
